import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const closeLeavingDialog: GraphCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.leavingDialog.open = false;
    draft.leavingDialog.continueCallback = null;
  });
};
